import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { ReportCategory } from "@bpm/models";
import { PagedData } from "@core/models/datables";
import { environment } from "environments/environment";

@Injectable({ providedIn: "root" })
export class ReportCategoryService {
  //EndPoint para controlador de este objeto en backend
  private reportCategoryApiURL = `${environment.bpmApiUrl}/api/report-categories`;

  constructor(private _http: HttpClient) {}

  /**
   * Obtiene un listado de categorías activas (para combos)
   * @returns Listado de categorías activas
   */
  getAllActive() {
    return this._http.get<ReportCategory[]>(`${this.reportCategoryApiURL}`).pipe(
      map((response: any) => response as ReportCategory[]),
      catchError((e) => {
        return throwError(e);
      })
    );
  }

  /**
   * Obtiene un listado paginado de categorías
   * @param {number} page Número de página
   * @param {number} quantity Cantidad por página
   * @returns Página de categorías
   */
  getAllPaged(page: number, quantity: number) {
    return this._http
      .get<PagedData<ReportCategory>>(`${this.reportCategoryApiURL}/page/${page}/${quantity}`)
      .pipe(
        map((response: any) => response as PagedData<ReportCategory>),
        catchError((e) => {
          return throwError(e);
        })
      );
  }

  /**
   * Obtiene una categoría por id
   * @param {number} reportCategoryId Id de la categoría
   */
  getById(reportCategoryId: number) {
    return this._http
      .get<ReportCategory>(`${this.reportCategoryApiURL}/${reportCategoryId}`)
      .pipe(
        map((response: any) => response as ReportCategory),
        catchError((e) => {
          return throwError(e);
        })
      );
  }

  /**
   * Crea una categoría
   * @param {ReportCategory} reportCategory Objeto a crear
   */
  create(reportCategory: ReportCategory) {
    return this._http
      .post<ReportCategory>(`${this.reportCategoryApiURL}`, reportCategory)
      .pipe(
        map((response: any) => response.reportCategory as ReportCategory),
        catchError((e) => {
          return throwError(e);
        })
      );
  }

  /**
   * Actualiza una categoría
   * @param {ReportCategory} reportCategory Objeto a actualizar
   */
  update(reportCategory: ReportCategory) {
    return this._http
      .put<ReportCategory>(`${this.reportCategoryApiURL}/${reportCategory.id}`, reportCategory)
      .pipe(
        map((response: any) => response.reportCategory as ReportCategory),
        catchError((e) => {
          return throwError(e);
        })
      );
  }

  /**
   * Elimina (lógico) una categoría
   * @param {number} reportCategoryId Id de la categoría
   */
  delete(reportCategoryId: number) {
    return this._http
      .delete<ReportCategory>(`${this.reportCategoryApiURL}/${reportCategoryId}`)
      .pipe(
        map((response: any) => response.reportCategory as ReportCategory),
        catchError((e) => {
          return throwError(e);
        })
      );
  }
}
